package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer

@Serializable
open class SignSymptomSetting(var id: String? = null){
	var group: String? = null
	var diagnosisSettingId: String? = null
	var signSymptomId: String? = null
	var isDoctorOnly: Boolean? = null
	var suggestion: String? = null
	var questionForYes: String? = null
	var questionForNo: String? = null
	var questionForMild: String? = null
	var questionForModerate: String? = null
	var questionForSerious: String? = null
	var createdBy: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var weight: Int? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomSetting
		if (id != other.id) return false
		if (group != other.group) return false
		if (diagnosisSettingId != other.diagnosisSettingId) return false
		if (signSymptomId != other.signSymptomId) return false
		if (isDoctorOnly != other.isDoctorOnly) return false
		if (suggestion != other.suggestion) return false
		if (questionForYes != other.questionForYes) return false
		if (questionForNo != other.questionForNo) return false
		if (questionForMild != other.questionForMild) return false
		if (questionForModerate != other.questionForModerate) return false
		if (questionForSerious != other.questionForSerious) return false
		if (createdBy != other.createdBy) return false
		if (createdOn != other.createdOn) return false
		if (weight != other.weight) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (group?.hashCode() ?: 0)
		result = 31 * result + (diagnosisSettingId?.hashCode() ?: 0)
		result = 31 * result + (signSymptomId?.hashCode() ?: 0)
		result = 31 * result + (isDoctorOnly?.hashCode() ?: 0)
		result = 31 * result + (suggestion?.hashCode() ?: 0)
		result = 31 * result + (questionForYes?.hashCode() ?: 0)
		result = 31 * result + (questionForNo?.hashCode() ?: 0)
		result = 31 * result + (questionForMild?.hashCode() ?: 0)
		result = 31 * result + (questionForModerate?.hashCode() ?: 0)
		result = 31 * result + (questionForSerious?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (weight?.hashCode() ?: 0)
		return result
	}

}
